export default __webpack_public_path__ + "static/media/coloquio_BannerWeb_5.80571888.jpg";